import { useState } from "react";
import { motion } from "framer-motion";
import { FileLock2 } from "lucide-react";
import { SUBSCRIPTION_TIERS, SUBSCRIPTION_TIER_NOTE } from "../../data/content";
import { ExecutiveTransmittalModal } from "./ExecutiveTransmittalModal";

export const SubscriptionTiers = () => {
  const [open, setOpen] = useState(false);
  return (
    <section id="subscription-tiers" className="py-20 md:py-28 bg-[#F8FAFC]" data-testid="subscription-tiers-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37] font-semibold">For Universities</p>
        <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl text-[#0B1B2B] tracking-tight max-w-3xl">
          University Subscription Tiers
        </h2>
        <p className="mt-5 text-[#64748B] leading-relaxed text-sm md:text-base max-w-3xl">
          Every program joins a tier matched to its specialty. Each tier is built around a small group of four
          students placed together. Tier names and focus areas are below; full pricing is shared privately.
        </p>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {SUBSCRIPTION_TIERS.map((t, idx) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="bg-white border border-[#E2E8F0] rounded-xl p-6 hover:border-[#D4AF37]/50 hover:shadow-lg transition-all duration-300"
              data-testid={`subscription-tier-${idx + 1}`}
            >
              <span className="text-[10px] font-bold tracking-[0.18em] uppercase px-2.5 py-1 rounded-full bg-[#0B1B2B] text-[#D4AF37]">{t.name}</span>
              <h3 className="mt-4 font-serif text-lg text-[#0B1B2B] font-semibold leading-snug">{t.specialty}</h3>
              <p className="mt-2 text-sm text-[#64748B] leading-relaxed">{t.desc}</p>
            </motion.div>
          ))}
        </div>
        <div className="mt-8 bg-[#0B1B2B] rounded-xl p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between">
          <p className="text-sm md:text-base text-slate-300 leading-relaxed max-w-2xl">{SUBSCRIPTION_TIER_NOTE}</p>
          <button
            onClick={() => setOpen(true)}
            className="shrink-0 bg-[#D4AF37] text-[#0B1B2B] font-semibold px-6 py-3.5 rounded-xl hover:bg-[#e8c968] transition-all duration-300 flex items-center justify-center gap-2"
            data-testid="request-executive-transmittal-button"
          >
            <FileLock2 size={16} />
            Request Executive Transmittal
          </button>
        </div>
      </div>
      <ExecutiveTransmittalModal open={open} onClose={() => setOpen(false)} />
    </section>
  );
};
